import {APIResponse, easasAxios} from "../services/HttpService";
import {AxiosInstance} from 'axios'
import {DatasetDataInfoResponse, ILicenseDataInfo, IUsersDataInfoResponse} from "./apiModels";
import {DatasetDataLagLeadRequest, UpdateDatasetData} from "./requests";

const API_SCOPE = "/datasetData";

export class DatasetDataApi {
    private httpClient: AxiosInstance;

    constructor(axiosInstance?: AxiosInstance) {
        console.log("DatasetDataApi obj created!")
        this.httpClient = axiosInstance ?? easasAxios; // Get default axios if not defined
    }

    async getDataInfo(identifiers: Array<string>, config?: DatasetDataLagLeadRequest): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        try {
            const {data} = await this.httpClient.post(`/dashboard/datasets/dataInfo`, {...config, identifiers});
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getRecentData(identifiers: Array<string>, count: number = 1,options?:any): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        try {
            const {data} = await this.httpClient.post(`${API_SCOPE}/dataInfoRecent`, identifiers, {params: {count: count, ...options}});
            return {data};
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async updateData(UpdateDatasetDataArray: Array<UpdateDatasetData>): Promise<APIResponse<Array<UpdateDatasetData>>> {
        try {
            const {data} = await this.httpClient.post(`${API_SCOPE}/update`, UpdateDatasetDataArray);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getDataInfoRange(identifiers: Array<string>, timeStart: string, timeEnd?: string): Promise<APIResponse<Array<DatasetDataInfoResponse>>> {
        try {
            let timeEndTemp = timeEnd ? timeEnd : timeStart;
            const {data} = await this.httpClient.post(`${API_SCOPE}/dataInfoRange?from=` + timeStart + `&to=` + timeEndTemp, identifiers);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getUsers(permission?: string) {
        try {
            let props: string = "/users";
            if (permission) {
                props = props + "?hasPermission=" + permission;
            }
            const {data} = await this.httpClient.get<Array<IUsersDataInfoResponse>>(props);
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }

    async getLicenses() {
        try {
            const {data} = await this.httpClient.get<Array<ILicenseDataInfo>>("/licences/licences")
            return {data}
        } catch (error: any) {
            console.error(error);
            return {error};
        }
    }
}

export const DatasetDataInfo = new DatasetDataApi();
